<template>
  <q-carousel-slide :class="slideClass" :name="name" :img-src="imgSrc">
    <slot />
  </q-carousel-slide>
</template>

<script>
export default {
  name: 'RCarouselSlide',
  props: {
    name: {
      type: [String, Number],
      required: true,
    },
    slideClass: String,
    imgSrc: String,
  },
};
</script>
